import * as React from 'react';
import styles from './styles.module.css';
import { UIText1 } from '../../../../typography';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestionTextItem = props => {
  return /*#__PURE__*/_jsx("li", {
    className: styles['item'],
    role: "option",
    tabIndex: -1,
    "data-testid": "suggesttion-text-item",
    children: /*#__PURE__*/_jsx(UIText1, {
      whiteSpace: "pre-wrap",
      color: "gray60_100",
      children: props.children
    })
  });
};